import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Collapse } from 'reactstrap';
import matchMedia from 'matchmediaquery';

import Icon from 'ui/common/rebranding/components/Icon';
import themeConfig from 'ui/theme/config';

class ProfileSection extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const { collapsible, isOpen } = this.props;

    this.state = {
      isOpen: typeof isOpen === 'undefined' ? collapsible : isOpen,
    };
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { title, actions, collapsible, className, canManage, buttonNextToToggle } = this.props;

    const hasOtherActions = canManage && buttonNextToToggle;
    const isMobile = matchMedia(`(max-width: ${themeConfig.layout.gridBreakpoints.md - 1}px)`)
      .matches;

    return (
      <section className={className}>
        <header className="row align-items-left justify-content-end border-bottom pb-2 mx-0">
          {title && (
            <h2 className="col-10 col-md-6 pl-0 typography-section-headline-small text-sm-center align-self-end">
              {title}
            </h2>
          )}
          <div className="col-2 col-md-3 text-right pr-0">
            {hasOtherActions && <div className="d-inline mr-1">{buttonNextToToggle}</div>}
            {collapsible && (
              <span className="d-inline">
                <Icon
                  key="collapse-action"
                  name={this.state.isOpen ? 'icon--arrow-up' : 'icon--arrow-down'}
                  tooltip={isMobile ? null : this.state.isOpen ? 'Minimize' : 'Maximize'}
                  background
                  onClick={this.toggle}
                />
              </span>
            )}
          </div>
        </header>

        <Collapse isOpen={this.state.isOpen} tag="main" className="pt-2">
          {this.props.children}
          <center className="py-3">{actions}</center>
        </Collapse>
      </section>
    );
  }
}

export default ProfileSection;
